<template>
  <b-button :class="isMasterBranch ? 'fw-bold btn-red' : 'fw-bold btn-blue'" size="sm" @click="goToCreateBranchModal">
    <i class="bx bx-git-branch fw-bold"></i>
    {{ isMasterBranch ? 'Main' : store.state.tms.webContainer.entity.name }}
  </b-button>
</template>
<script setup>
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { computed } from 'vue';

const store = useStore();
const router = useRouter();

const isMasterBranch = computed(() => !store.getters['tms/webContainer/isBranch']);

const goToCreateBranchModal = () => {
  router.push({
    name: 'web-containers-edit',
    params: { modal: 'branch' },
    query: { branchModalOpen: true },
  });
};
</script>
<style lang="scss" scoped>
@import '@styles/variables.scss';
.btn-red {
  background-color: $commandersact !important;
  border-color: $commandersact !important;
}

.btn-blue {
  background-color: $commandersactblue !important;
  border-color: $commandersactblue !important;
}
</style>
